import type { BrandsListData } from "@similarweb/pro-api-client";

import { apiClient } from "app/modules/api-client";

export const BRAND_AUTOCOMPLETE_SIZE = 20;

export const fetchBrandAutocomplete = async (term: string): Promise<BrandsListData> => {
    const trimmedTerm = term.trim();
    if (!trimmedTerm) {
        return [];
    }

    const result = await apiClient.Brands.brandsList({
        term: trimmedTerm,
        size: BRAND_AUTOCOMPLETE_SIZE,
    });

    return Array.isArray(result) ? result : [];
};
